import { destroyData } from "../../http";

export const removePost = async (id: string): Promise<void> => {
  console.debug("[ServiceApi] removePost", id);
  const post = new (Parse.Object.extend("Post"))({ id: id });
  await destroyData(post, null, {});
};
